import React, { FC, useCallback, useEffect, useState } from "react";
import { DatePicker, Select } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { I18n } from "react-redux-i18n";
import { LabelValue } from "../../../../../../types/labelValue";
import StatisticsLayout from "../../../../../../components/statisticsLayout";
import { ColumnChart } from "../../../../../../components/charts";
import { requestApi } from "../../../../../../utils/requestApi";
import { POST } from "../../../../../../types/httpMethod";
import { DATE_FORMAT } from "../../../../../../utils";
import { useParams } from "react-router-dom";
import { mapMonthList } from "../helpers";
import { FilterStatus } from "../../../../../../types/filterStatusValue";
import { getStatusFilterOptions } from "../../../../../../utils/getStatusFilterOptions";

type AnswersByDaysProps = {
  filterStatus?: FilterStatus;
  setFilterStatus?: (value: FilterStatus) => void;
};

const AnswersByDays: FC<AnswersByDaysProps> = ({ filterStatus, setFilterStatus }) => {
  const { id: surveyId } = useParams();
  const [selectedFilter, setSelectedFilter] = useState<Dayjs>(dayjs(new Date()));
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState<Array<LabelValue>>([]);
  const stateOption = getStatusFilterOptions();

  const onFilter = useCallback((value: Dayjs | null) => {
    if (value) {
      setSelectedFilter(value);
      loadData(value.format(DATE_FORMAT));
    }
  }, []);

  const loadData = useCallback(
    (date?: string, state: string = FilterStatus.ALL) => {
      setLoading(true);
      requestApi(
        POST,
        "/chart/answers-by-day",
        { month: date || selectedFilter.format(DATE_FORMAT), state: state },
        false,
        false,
        {},
        { surveyId },
      )
        .then((res) => setData(mapMonthList(res)))
        .finally(() => setLoading(false));
    },
    [selectedFilter, surveyId],
  );

  const handleStatusChange = (value: FilterStatus) => {
    setFilterStatus?.(value);
    loadData(undefined, value);
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div style={{ color: "#000000", flex: 1 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <h3 style={{ fontWeight: 600, margin: 0 }}>{I18n.t("answersByDays")}</h3>
        <div style={{ marginRight: "auto", marginLeft: 20 }}>
          <Select
            value={filterStatus}
            style={{ width: 160 }}
            onChange={handleStatusChange}
            placeholder={I18n.t("selectStatus")}
          >
            {stateOption.map((option: any) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </div>
      </div>

      <StatisticsLayout hideTitle={true}>
        <DatePicker
          inputReadOnly
          picker={"month"}
          allowClear={false}
          onChange={onFilter}
          format={"MMMM YYYY"}
          value={selectedFilter}
          style={{ width: 160, marginBottom: 24 }}
        />
        <ColumnChart data={data} loading={isLoading} height={400} />
      </StatisticsLayout>
    </div>
  );
};

export default AnswersByDays;
